module.exports = __webpack_public_path__ + "img/fgl_fgltokenmgmt.f82e2f8.png";